(() => {
  'use strict';
  const PLACE_ID = 'ChIJUUYuG5PNyUcRxq95FwZ1mzM';
  const TTL = 15 * 60 * 1000;
  let current = null;
  let checkedAt = 0;
  let pending = null;

  function normalize(data) {
    if (data?.place_id !== PLACE_ID) return null;
    const rating = Number(data.average_rating);
    const count = Number(data.user_ratings_total);
    if (!Number.isFinite(rating) || rating < 1 || rating > 5 ||
        !Number.isSafeInteger(count) || count < 1) return null;
    return { rating, count };
  }

  function render(data) {
    const locale = document.documentElement.lang || 'nl-NL';
    const rating = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(data.rating);
    document.querySelectorAll('[data-google-rating]').forEach(node => {
      node.textContent = rating;
      node.dataset.reviewSource = 'repocean';
    });
    document.querySelectorAll('[data-google-review-count]').forEach(node => {
      node.textContent = (node.dataset.countLabel || '__COUNT__ reviews').replace('__COUNT__', String(data.count));
      node.dataset.reviewSource = 'repocean';
    });
  }

  async function refresh(force = false) {
    if (!document.querySelector('[data-google-rating], [data-google-review-count]')) return;
    if (current) render(current);
    if (pending || (force !== true && Date.now() - checkedAt < TTL)) return pending;
    pending = (async () => {
      try {
        const response = await fetch('/apps/repocean-reviews', { signal: AbortSignal.timeout(10000), headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Review source unavailable');
        const data = normalize(await response.json());
        if (!data) throw new Error('Invalid review summary');
        current = data;
        render(data);
      } catch {
        // Keep the server-rendered snapshot or last successful response.
      } finally {
        checkedAt = Date.now();
        pending = null;
      }
    })();
    return pending;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  setInterval(() => {
    // The timer bounds polling; do not delay an interval by the last response time.
    if (!document.hidden) refresh(true);
  }, TTL);
})();
